<template>
    <div id="cashOut">
        <Headers :headersText='headersText'></Headers>
        <!-- 选择方式 -->
        <div class="selectMode">
            <div class="modesBox" :style="{borderBottom:(selectMode == 0 ? '3px solid #41B035' : ''),opacity:(selectMode == 0 ? '' : '.6')}" @click="chooseMode(0)">
                <div class="modes">
                    <img src="../assets/images/img_38.png" alt="">
                    <span>微信提现</span>
                </div>
            </div>
            <div class="modesBox" :style="{borderBottom:(selectMode == 1 ? '3px solid #08A1F8' : ''),opacity:(selectMode == 1 ? '' : '.6')}" @click="chooseMode(1)">
                <div class="modes">
                    <img src="../assets/images/img_36.png" alt="">
                    <span>支付宝提现</span>
                </div>
            </div>
        </div>
        <!-- 微信方式 -->
        <div class="WXmode" v-if="selectMode == 0">
            <input type="text" placeholder="输入微信绑定的真实姓名" v-model="wxName" id="wxNames">
            <div class="chooseMoney">
                <div class="title">选择提现金额</div>
                <div class="chooseNum">
                    <div v-for="(item,index) in cashOutMoney" :key="index" :style="{border:(index == wxChoose ? '1px solid #E50113' : '1px solid #E5E5E5'),color:(index == wxChoose ? '#E50113' : '')}" @click="chooseNumsW(index)">{{item}}元</div>
                </div>
            </div>
            <div class="btn" @click="wxCashOut">确认提现</div>
            <div class="text">
                <div>每日可申请提现一次</div>
                <div>工作日提现次日24点前到账</div>
                <div>周五、周六、周日提现延至周一到账</div>
            </div>
        </div>
        <!-- 支付宝方式 -->
        <div class="ZFBmode" v-else-if="selectMode == 1">
            <input type="text" placeholder="输入支付宝账号" v-model="zfbNum" class="zfbNums" readonly  @click="remind()" unselectable="on" onfocus="this.blur()">
            <input type="text" placeholder="输入支付宝姓名" v-model="zfbName" class="zfbNames" readonly  @click="remind()" unselectable="on" onfocus="this.blur()">
            <div class="chooseMoney">
                <div class="title">选择提现金额</div>
                <div class="chooseNum">
                    <div v-for="(ite,ind) in cashOutMoney" :key="ind" :style="{border:(ind == zfbChoose ? '1px solid #E50113' : '1px solid #E5E5E5'),color:(ind == zfbChoose ? '#E50113' : '')}" @click="chooseNumsZ(ind)">{{ite}}元</div>
                </div>
            </div>
            <div class="btn" @click="zfbCashOut">确认提现</div>
            <div class="text">
                <div>每日可申请提现一次</div>
                <div>工作日提现次日24点前到账</div>
                <div>周五、周六、周日提现延至周一到账</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers,
        },
        data() {
            return {
                headersText:'选择提现方式',
                selectMode:0,

                wxName:'', // 微信绑定的真实姓名
                cashOutMoney:[10,30,50,100,500], // 选择金额
                wxChoose:0, // 微信提现金额(index)
                wxMoney:10, // 微信提现金额

                zfbNum:'', // 支付宝账号
                zfbName:'', // 支付宝姓名
                zfbChoose:0, // 支付宝提现金额(index)
                zfbMoney:10, // 支付宝提现金额

                defaultType:[], // 默认可支付方式
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            // 初始化 接口调用
            init(){
                this.$loading(true);
                let datas = {}
                this.$http.GETS('User/chooseCashMode',datas,(res)=>{
                    console.log(res.data);
                    if(res.data.default == 'alipay'){
                        this.selectMode = 1
                    } else {
                        this.selectMode = 0
                    }
                    this.defaultType = res.data.type
                    this.wxName = res.data.wx_name
                    this.zfbName = res.data.ali_name
                    this.zfbNum = res.data.ali_account
                    this.$loading(false);
                });
            },
            // 选择方式
            chooseMode:function(nums){
                if(nums == 0){
                    if(this.defaultType.indexOf('weixin') == -1){
                        this.$toast('暂不支持微信提现')
                    } else {
                        this.selectMode = nums;
                    }
                } else if(nums == 1) {
                    if(this.defaultType.indexOf('alipay') == -1){
                        this.$toast('暂不支持支付宝提现')
                    } else {
                        this.selectMode = nums;
                    }
                }
                
            },
            remind() {
                this.$toast('如需修改认证信息，请联系客服处理')
            },
            // 选择微信提现金额
            chooseNumsW(indexs){
                this.wxChoose = indexs;
                this.wxMoney = this.cashOutMoney[indexs];
            },
            // 选择支付宝提现金额
            chooseNumsZ(indexs){
                this.zfbChoose = indexs
                this.zfbMoney = this.cashOutMoney[indexs];
            },

            // 微信 确认提现
            wxCashOut(){
                this.$loading(true);
                let datas = {
                    cash_type:'weixin',
                    cash_amount:this.wxMoney,
                    wx_name:this.wxName
                }
                this.$http.POSTS('User/commitCashApply',datas,(res)=>{
                    this.$loading(false);
                    this.$router.push({name:'cashOutSuccess',query: {cash_amount:this.wxMoney}});
                    // this.$router.push('/cashOutSuccess')
                });
                // this.$router.push({name:'cashOutSuccess',query: {cash_amount:this.wxMoney}});
            },

            // 支付宝 确认提现
            zfbCashOut(){
                this.$loading(true);
                let datas = {
                    cash_type:'alipay',
                    cash_amount:this.zfbMoney,
                    ali_name:this.zfbName,
                    ali_account:this.zfbNum
                }
                this.$http.POSTS('User/commitCashApply',datas,(res)=>{
                    this.$loading(false);
                    this.$router.push({name:'cashOutSuccess',query: {cash_amount:this.zfbMoney}});                    
                    // this.$router.push('/cashOutSuccess')
                });
                // this.$router.push({name:'cashOutSuccess',query: {cash_amount:this.zfbMoney}});
            }
        },

    }
</script>

<style lang="less" scoped>
    #cashOut{
        // 选择方式
        .selectMode{
            padding: 10px 0 0;
            display: flex;
            background: #FFFFFF;
            .modesBox{
                width: 50%;
                .modes{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 10px;
                    border-right: 1px solid #E5E5E5;
                    img{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        font-size: 15px;
                        color: #232524;
                        margin-left: 10px;
                    }
                }
            }
            
        }

        // 公共样式
        .chooseMoney{
            .title{
                color: #232524;
                font-size: 15px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .chooseNum{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                div{
                    background: #FFFFFF;
                    width: 160px;
                    height: 50px;
                    // border: 1px solid #E5E5E5;
                    font-weight: bold;
                    box-sizing: border-box;
                    border-radius: 5px;
                    font-size: 18px;
                    color: #151515;
                    text-align: center;
                    line-height: 50px;
                    margin: 10px 0;
                }
            }
        }
        .btn{
            width: 335px;
            height: 50px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            border-radius: 25px;
            color: #FFFFFF;
            font-size: 15px;
            text-align: center;
            line-height: 50px;
            box-shadow: 0 5px 10px rgba(229, 1, 19, .15);
            margin-top: 30px;
        }
        .text{
            font-size: 13px;
            color: #999999;
            text-align: center;
            margin-top: 25px;
            line-height: 22px;
            padding-bottom: 15px;
        }

        // 微信方式
        .WXmode{
            padding: 0 20px;
            #wxNames{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                border-radius: 5px;
                text-align: center;
                margin: 30px 0px;
                padding: 0 20px;
                box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
                &:focus{
                    // border-radius: 5px;
                    outline:none;
                    // border-color: #E50113!important;
                    // border:1px solid #E50113;
                }
            }
            
        }

        // 支付宝方式
        .ZFBmode{
            padding: 0 20px;
            .zfbNums{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                border-radius: 5px 5px 0 0;
                text-align: center;
                padding: 0 20px;
                margin-top: 30px;
                box-shadow:0px 5px 10px rgba(0,0,0,.1);
                margin-bottom: 1px;
                &:focus{
                    outline:none;
                }
            }
            .zfbNames{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                border-radius: 0 0 5px 5px;
                text-align: center;
                padding: 0 20px;
                box-shadow:0px 5px 10px rgba(0,0,0,.1);
                margin-bottom: 30px;
                &:focus{
                    outline:none;
                }
            }
        }
    }
</style>